import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { Link } from "react-router-dom";
import HealthPlanComparison from "../components/HealthPlanComparison";

const PlanPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T2792001XT2");
  const [isRider, setIsRider] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [memberCount, setMemberCount] = useState(0);
  const [showRC, setShowRC] = useState(false);

  return (
    <div>
      {/* ======= Pricing =======*/}
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Plans
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Plan for every budget
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Experience modern, stress-free healthcare with our trusted OPD and wellness services.
              </p>
            </div>
          </div>

          <HealthPlanComparison />


          <div className="row">
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Essential Health Plan
                </span>
                <div className="price mb-2">
                  <strong>₹999</strong>
                  <span>+ GST</span>
                </div>

                <div className="btn"
                  onClick={() => {
                    setPlanCode("EssentialHealth");
                    setOpenPopup(true);
                    setIsRider(false);
                    setMemberCount(0);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <div className="flex items-center gap-1 mb-3 flex-wrap">
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Member Coverage: individual
                    </div>
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Plan Validity: 1 Year
                    </div>
                  </div>
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>6 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on 2 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on Diagnostic & Radiology </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Advantage Health Plan
                </span>
                <div className="price mb-2">
                  <strong>₹4,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="btn"
                  onClick={() => {
                    setPlanCode("AdvantageHealth");
                    setOpenPopup(true);
                    setIsRider(false);
                    setMemberCount(3);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <div className="flex items-center gap-1 mb-3 flex-wrap">
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Member Coverage: 2 Adults and 2 Childrens
                    </div>
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Plan Validity: 1 Year
                    </div>
                  </div>
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>5 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>5 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Virtual Diabetic Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on In-person General Physician Clinic & Hospital Consultation or upto Rs.500 reimbursement for My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Virtual Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on Diagnostic & Radiology </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Supreme Health Plan
                </span>
                <div className="price mb-2">
                  <strong>₹9,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="btn"
                  onClick={() => {
                    setPlanCode("SupremeHealth");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(3);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <div className="flex items-center gap-1 mb-3 flex-wrap">
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Member Coverage: 2 Adults and 2 Childrens
                    </div>
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Plan Validity: 1 Year
                    </div>
                  </div>
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>5 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>5 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹1,000 - Diagnostic & Radiology Wallet</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Virtual Diabetic Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on In-person General Physician Clinic & Hospital Consultation or upto Rs.500 reimbursement for My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Virtual Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on Diagnostic & Radiology </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Infinity Health Plan
                </span>
                <div className="price mb-2">
                  <strong>₹14,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="btn"
                  onClick={() => {
                    setPlanCode("InfinityHealth");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(3);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <div className="flex items-center gap-1 mb-3 flex-wrap">
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Member Coverage: 2 Adults and 2 Childrens
                    </div>
                    <div
                      className="subtitle text-uppercase"
                      data-aos="fade-up"
                      data-aos-delay={0}
                    >
                      Plan Validity: 1 Year
                    </div>
                  </div>
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credits on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹2,000 - Diagnostic & Radiology Wallet</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>1 Credit on Virtual Diabetic Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on In-person General Physician Clinic & Hospital Consultation or upto Rs.500 reimbursement for My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>6 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Virtual Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credit on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Group Personal Accident Rider</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹15 Lakh Sum Insured </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Accidental Death  </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Covered Permanent Total Disability (Upto 100% SI Paid on PTD)</span>
                    </li>
                  </ul>
                  
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on Diagnostic & Radiology </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay={300}>
              <div className="p-5 rounded-4 price-table h-100">
                <span
                  className="subtitle text-uppercase mb-3"
                  data-aos="fade-up"
                  data-aos-delay={0}
                >
                  Prime Infinity Health Plan
                </span>
                <div className="price mb-2">
                  <strong>₹19,999</strong>
                  <span>+ GST</span>
                </div>
                <div className="btn"
                  onClick={() => {
                    setPlanCode("PrimeInfinityHealth");
                    setOpenPopup(true);
                    setIsRider(true);
                    setMemberCount(1);
                    setShowMember(false);
                    setShowRC(false);
                  }}>
                  Buy Plan
                </div>
                <div className="col-md-12 mt-[30px] pricing-features">
                  <h4 className="text-uppercase fw-bold mb-3">What's included</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Unlimited on Tele Doctor Consultation: GP </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Unlimited on Tele Doctor Consultation: Ayurvedic</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Unlimited on Tele Doctor Consultation: Homeopathy</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Unlimited on Tele Doctor Consultation: 18+ Specialist</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 credits - Full Body Checkup (56 parameters)</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>₹3,500 - Diagnostic & Radiology Wallet</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits worth ₹2,000 on Virtual Diabetic Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>6 Credit OR 500 per consultation on In-person General Physician Clinic & Hospital Consultation / My Choice Doctor</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>10 Credit on General Physician/CP Video Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Pharmacy Wallet - Prescribed Medicines</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>2 Credits worth ₹2,000 on Dental Check-up and Consultation</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits worth ₹4,800 on Virtual Mental Wellness</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>4 Credits worth ₹4,800 on Tele Dietician Consultation</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Inclusive Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Risk Assessment </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Health Reminder</span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Applicable Recorded Fitness sessions</span>
                    </li>
                  </ul>
                  <h4 className="text-uppercase fw-bold mb-3">Platform Benefits</h4>
                  <ul className="list-unstyled mb-3 d-flex flex-column gap-3">
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 50% off on Diagnostic & Radiology </span>
                    </li>
                    <li className="d-flex gap-2 align-items-start mb-0">
                      <span className="icon rounded-circle position-relative mt-1">
                        <i className="bi bi-check" />
                      </span>
                      <span>Upto 20% off on Prescribed Medicines</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* End Pricing*/}

      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
        showMember={showMember}
        memberCount={memberCount}
        showRC={showRC}
      />
    </div>
  );
};

export default PlanPage;
